// @flow
import React, { Component } from 'react';
import { TouchableOpacity, StyleSheet, View } from 'react-native';
import { ActivityIndicator, Text } from 'trpc-react-native-ui';
import { Icon } from './index';
import theme from '../../theme-config';

type Props = {
  children?: any,
  first?: boolean,
  iconName?: string,
  isLoading?: boolean,
  label?: string,
  labelStyle?: Object,
  onPress?: Function,
  renderArrow?: () => React$Element<any>,
  value?: string,
};

const TEXT_NUMBER_OF_LINES = 2;

class ItemsPickerButton extends Component<Props> {
  renderBody() {
    const { children, iconName, label, value, labelStyle } = this.props;

    if (children) {
      return children;
    }

    return (
      <View style={styles.start}>
        {iconName && <Icon name={iconName} size={24} style={styles.icon} />}
        <View style={styles.textContainer}>
          <Text numberOfLines={TEXT_NUMBER_OF_LINES} style={[styles.label, labelStyle]}>
            {label}
          </Text>
        </View>
        {value && (
          <View style={styles.textContainer}>
            <Text style={styles.value}>{value}</Text>
          </View>
        )}
      </View>
    );
  }

  renderIcon(isButtonEnabled: boolean) {
    const { isLoading, renderArrow } = this.props;

    if (isButtonEnabled && !isLoading && renderArrow) {
      return renderArrow();
    } else if (isLoading && renderArrow) {
      return <ActivityIndicator />;
    }
  }

  render() {
    const { onPress, first, isLoading } = this.props;

    const isButtonEnabled = !!onPress;

    return (
      <TouchableOpacity onPress={onPress} disabled={!isButtonEnabled || isLoading}>
        <View style={[styles.container, first && styles.firstContainer]}>
          {this.renderBody()}
          {this.renderIcon(isButtonEnabled)}
        </View>
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    padding: 18,
    borderBottomWidth: 1,
    borderColor: theme.gray.light,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  firstContainer: {
    borderTopWidth: 1,
  },
  start: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
  },
  textContainer: {
    flex: 1,
    alignItems: 'flex-start',
  },
  label: {
    fontWeight: '500',
    fontSize: 14,
    color: theme.manageLines.textColor,
    marginRight: 15,
  },
  value: {
    fontWeight: '300',
    fontSize: 14,
    color: theme.manageLines.textColor,
  },
  icon: {
    color: theme.manageLines.iconColor,
    paddingRight: 18,
  },
});

export default ItemsPickerButton;
